<ion-header><app-page-header subtitle="Ideas"></app-page-header></ion-header>

<ion-content>
  <ion-card class="ion-padding" *ngIf="idea">
    <ion-card-title>Ideas</ion-card-title>
    <p class="kps-pre-line">{{ idea.row.idea }}</p>
  </ion-card>
</ion-content>
